import { ChangeEventHandler, useEffect, useRef } from 'react';
import cn from 'classnames';
import styles from './IndeterminateCheckbox.module.scss';

interface CheckboxProps {
  uniqueKey: string;
  name: string;
  checked: boolean;
  onChange: ChangeEventHandler<HTMLInputElement>;
  indeterminate?: boolean;
  className?: string;
  disabled?: boolean;
}

export const IndeterminateCheckbox = (props: CheckboxProps) => {
  const {
    className,
    onChange,
    checked = false,
    name,
    uniqueKey,
    disabled = false,
    indeterminate,
  } = props;

  const checkboxRef = useRef<HTMLInputElement>(null!);

  useEffect(() => {
    if (indeterminate !== undefined) {
      checkboxRef.current.indeterminate = !checked && indeterminate;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkboxRef, indeterminate]);

  return (
    <input
      id={uniqueKey}
      name={name}
      type="checkbox"
      ref={checkboxRef}
      className={cn(styles.checkbox, [className])}
      disabled={disabled}
      checked={checked}
      onChange={onChange}
      onClick={(e) => e.stopPropagation()}
    />
  );
};
